<template>
  <router-link to="/ostern" class="easter is-block is-clipped is-relative">
    <div class="columns  is-multiline is-vcentered" v-if="$whitelabel.short.toLowerCase() === 'adac'">
      <div
        class="column is-8-tablet is-offset-2-tablet is-6-desktop is-offset-0-desktop easter__content easter__content--adac mt-3">
        <div class="has-text-centered-touch easter__text--adac">
          <div
            class="title is-inline-block is-size-3-mobile is-size-2-tablet is-size-1-widescreen has-text-weight-bold u-p05 has-text-black">
            <p
              class="has-background-primary is-size-5 is-size-3-tablet  is-inline-block has-text-weight-bold  pr-1 pl-1 mb-3">
              ADAC Hotelgutschein
            </p>

            <p>
              <span class="is-inline-block-tablet is-block-mobile has-text-white">Frühlings&shy;erwachen <span
                  class="is-hidden-mobile">-</span> </span> <span class="is-inline-block">Endlich wieder raus!</span>
            </p>
          </div>
          <p class=" has-text-black is-size-6 is-size-5-tablet has-text-weight-bold">Ausgewählte Hotels für Ihren Aktiv-
            & Erholungsurlaub.</p>

          <b-button tag="router-link" to="/ostern" type="is-light" size="is-medium" class="mt-5">
            Hier klicken & kaufen!
          </b-button>
        </div>
      </div>
      <div class="column is-12-tablet is-6-desktop pl-6 pr-6 pt-5 pb-5 easter__img--adac">
        <p class=" has-text-centered has-text-right-desktop">
          <img fetchpriority="high"
            :src="`https://assets.urlaubsgutschein.kaufen/i/resize?width=700&quality=50&type=auto&interlace=true&file=whitelabel/adac/campaigns/ostern.png`"
            alt="Ostern" width="600" height="288" />
        </p>
      </div>
    </div>

    <img fetchpriority="high" class="easter-bunny"
      :src="`https://assets.urlaubsgutschein.kaufen/whitelabel/adac/campaigns/osterhase.svg`" alt="Osterhase"
      width="118" height="300" />
  </router-link>
</template>

<script>
export default {
  name: 'easter',

  props: {},
  methods: {},
}
</script>

<style scoped lang="scss">
.easter {
  background-color: #86a935;

  .title {
    margin-bottom: 0.75rem;
  }
}

.easter-bunny {
  position: absolute;
  bottom: -3.6vw;
  right: 0.6rem;
  width: 20vw;

  @media screen and (min-width: 769px) {
    bottom: -2.5rem;
    width: 160px;
  }
}

.easter__content {
  @media screen and (min-width: 769px) {
    margin-top: 3rem;
  }
}

.easter__text--adac {}

@media screen and (min-width: 1024px) {
  .easter__text--adac {
    margin-top: 1rem;
    margin-bottom: 2rem;
    margin-left: 3rem;
    margin-right: 0;
  }

  .easter__img--adac {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
}

@media screen and (min-width: 1216px) {
  .easter__img--adac {
    margin-right: 3rem;
    margin-left: -4rem;
  }
}
</style>
